import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "emissionFactors",
  initialState: {
    list: [],
    count: 0,
  },
  reducers: {
    setEmissionFactors: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },

    countEmissionFactors: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
  },
});

export const { setEmissionFactors, countEmissionFactors } = slice.actions;

export default slice.reducer;

export const getEmissionFactorsSelector = (store) => store.emissionFactors?.list || [];
export const getEmissionFactorsCountSelector = (store) => store.emissionFactors?.count || 0;